import type { ReactNode } from 'react';
import { AppFrame } from '../frame/AppFrame';

/**
 * The page frame for community pages: mogzo.com's phone-first frame (M28). `title` gives the
 * phone header a back button and the community's name.
 */
export function CommunityShell({ title, children }: { title?: string; children: ReactNode }) {
  return <AppFrame title={title}>{children}</AppFrame>;
}

/** A centred white card for "private", "not found" and similar states. */
export function NoticeCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="mx-auto w-full max-w-[520px] px-4 py-12 sm:px-6">
      <div className="rounded-3xl border border-line bg-card p-7">
        <h1 className="text-2xl font-bold">{title}</h1>
        <div className="mt-3 space-y-4 leading-relaxed text-muted">{children}</div>
      </div>
    </main>
  );
}
